module.exports = __webpack_public_path__ + "fonts/aZMswpodYeVhtRvuABJWvBkAz4rYn47Zy2rvigWQf6w.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/aZMswpodYeVhtRvuABJWvBkAz4rYn47Zy2rvigWQf6w.woff2
// module id = 314
// module chunks = 0